import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/earthquake_intensity.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  id: "mapEarthquakeOL",
  style: {"position":"fixed","background-color":"#fff","top":"0","left":"0","margin-top":"68px"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "popup-earthquake",
    class: "ol-popup"
  })
], -1)
const _hoisted_2 = { class: "nav-area" }
const _hoisted_3 = { class: "selector margin-right" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { id: "e-head" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { id: "message-area" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "quake-link" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { id: "guide" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)

import { ref, onMounted } from 'vue'
import { useInitDataStore } from '@/stores/initDataStore'
import axios from 'axios'
import $ from 'jquery'
import { OlMap } from '@/lib/olmap'
import moment from 'moment'
import ControllPanel from '@/components/common/EarthquakeControllPanel.vue'
import EarthquakeUdcSelect from '@/components/common/EarthquakeUdcSelect.vue'
import { Option } from '@/components/common/UdcSelect.vue'

type historyTarget = {
  prev: string
  now: string
  next: string
}

type prefType = {
  code: string
  maxIntensity: string
  name: string
}
type earthquakeDetailType = {
  city: [
    {
      code: string
      maxIntensity: string
      name: string
    }
  ]
  eventId: string
  hypocenter: {
    area: {
      code: string
      depth: number
      description: string
      latitude: number
      longitude: number
      name: number
    }
    id: string
  }
  id: string
  intensityStation: [
    {
      code: string
      intensity: string
      latitude: number
      longitude: number
      name: string
    }
  ]
  pref: [prefType]
  targetTime: string
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isArrowPush = ref<boolean>(false)
const isDateChange = ref<boolean>(false)

let map: OlMap

const initDataStore = useInitDataStore()
const selected = ref<string | undefined>()

let prefs = ref<Option[]>()

let pointLatitude = 0
let pointLongitude = 0

let isOpened = false

const earthquakeInformations = ref<Option[]>()
const historyTargets = ref<historyTarget>()
const earthquakeDetail = ref<earthquakeDetailType>()
const earthquakeDetailTime = ref<string>()
const earthquakePref = ref<string>()
let historyIDs: string[]

// マップの描画範囲を変更し、マップをリロード
const earthQuakeMapReload = async () => {
  if (earthquakeDetail.value) {
    let mapArea = $('#mapEarthquakeOL .ol-viewport')
    mapArea.eq(0).remove()

    const mapPositionData = {
      defaultLimitLeftUpLatitude: initDataStore.initData.definitionInfo.earthquake.rangeLimit.leftUp.latitude,
      defaultLimitLeftUpLongitude: initDataStore.initData.definitionInfo.earthquake.rangeLimit.leftUp.longitude,
      defaultLimitRightDownLatitude: initDataStore.initData.definitionInfo.earthquake.rangeLimit.rightDown.latitude,
      defaultLimitRightDownLongitude: initDataStore.initData.definitionInfo.earthquake.rangeLimit.rightDown.longitude,
      defaultLimitZoomDefault: initDataStore.initData.definitionInfo.earthquake.rangeLimit.zoom.default,
      defaultLimitZoomMax: initDataStore.initData.definitionInfo.earthquake.rangeLimit.zoom.max,
      defaultLimitZoomMin: initDataStore.initData.definitionInfo.earthquake.rangeLimit.zoom.min,
      defaultLatitude: pointLatitude,
      defaultLongitude: pointLongitude,
    }

    map = new OlMap()
    const mapSource = initDataStore.initData.systemInfo.mapInfo.mapSource
    map.init('mapEarthquakeOL', mapPositionData, mapSource)
    map.setPosition(
      earthquakeDetail.value.hypocenter.area.longitude,
      earthquakeDetail.value.hypocenter.area.latitude,
      mapPositionData.defaultLimitZoomDefault
    )

    map.setEarthquakeStations(
      earthquakeDetail.value.hypocenter.area.longitude,
      earthquakeDetail.value.hypocenter.area.latitude,
      earthquakeDetail.value.intensityStation
    )
  }
}

const setEarthquakeHistory = async () => {
  let result = null
  const time = moment()
  const start = moment(time).add(-1, 'month').toDate().toISOString()
  const end = time.toDate().toISOString()
  try {
    const body = {
      range: {
        start_time: start,
        end_time: end,
      },
    }
    result = await axios.post(`/api/earthquake/history`, body)
  } catch (err) {
    // console.log('setEarthquakeHistory error')
    // console.log(err)
  }
  isArrowPush.value = true
  let tmp_array = [] as Option[]
  historyIDs = []
  selected.value = ''
  if (result && result.data) {
    if (result.data.items.length > 0) {
      let reverseItems = result.data.items.reverse()
      earthquakeInformations.value = reverseItems.map((earthDetail: earthquakeDetailType) => {
        earthDetail.pref.map((item: prefType) => {
          tmp_array.push({
            label: item.name,
            value: item.code,
          } as Option)
        })

        let r = false
        if (earthquakePref.value && earthquakePref.value.length > 0) {
          let pref_search = earthDetail.pref.filter((pref: prefType) => {
            return pref.code === earthquakePref.value
          })
          if (pref_search.length > 0) r = true
        } else {
          r = true
        }
        if (!r) return

        if (selected.value == '') selected.value = earthDetail.id

        historyIDs.push(earthDetail.id as string)
        return {
          label: moment(earthDetail.targetTime).format('MM月DD日HH時mm分発表'),
          value: earthDetail.id,
        }
      }) as Option[]

      earthquakeInformations.value = earthquakeInformations.value.filter(Boolean)

      setEarthquakeInfo()
      setCursolTargets()
    }
    if (tmp_array.length > 0) {
      prefs.value = tmp_array
        .filter((item, index, self) => {
          const nameList = self.map(item => item.value)
          if (nameList.indexOf(item.value) === index) {
            return item
          }
        })
        .sort((a, b) => Number(a.value) - Number(b.value))
    }
    prefs.value?.unshift({
      label: '全国',
      value: '',
    } as Option)
  }
}

const setEarthquakeInfo = async () => {
  let result = null
  if (selected.value) {
    try {
      const body = {
        id: selected.value,
      }
      result = await axios.post(`/api/earthquake/detail`, body)
    } catch (err) {
      // console.log('setEarthquakeInfo error')
      // console.log(err)
    }
  }
  isDateChange.value = false
  if (result && result.data) {
    earthquakeDetail.value = result.data
    earthquakeDetailTime.value = selected.value
    // セレクトした場所の緯度経度を取得
    pointLatitude = result.data.hypocenter.area.latitude
    pointLongitude = result.data.hypocenter.area.longitude
    // それをもとに再描画
    earthQuakeMapReload()
    $('#message-area').html(
      `<p class="point-name">震源地：${result.data.hypocenter.area.name}</p>
      <p class="point-magnitude">地震の規模：${result.data.magnitude.description}</p>
      <p class="point-arrivalTime">発生日時：${moment(result.data.arrivalTime).format('MM月DD日HH時mm分ごろ')}</p>
      <p class="point-description">位置情報：${result.data.hypocenter.area.description}</p>
      <p class="point-depth">震源の深さ：約${Math.floor(result.data.hypocenter.area.depth / 1000)}km</p>`
    )
  }
}

const setCursolTargets = () => {
  if (selected.value) {
    let index = historyIDs.indexOf(selected.value) as number
    let prev = historyIDs[0]
    let now = historyIDs[0]
    let next = historyIDs[0]
    if (historyIDs.length > 1) {
      prev = historyIDs[index + 1] ? historyIDs[index + 1] : historyIDs[index]
      next = historyIDs[index - 1] ? historyIDs[index - 1] : historyIDs[index]
    }
    historyTargets.value = {
      prev: prev,
      now: now,
      next: next,
    }
  }
}

onMounted(() => {
  setEarthquakeHistory()
  $('.top-view-selector').hide()
  $('.icons-bot').hide()
})

const handleChangeTarget = (id: string) => {
  isArrowPush.value = true
  if (id && !isDateChange.value) {
    selected.value = id
    setEarthquakeInfo()
    setCursolTargets()
  }
}

const handleChangePref = (id: string) => {
  earthquakePref.value = id
  setEarthquakeHistory()
  setEarthquakeInfo()
  setCursolTargets()
}

const handleChangeDetailTime = (id: string) => {
  isDateChange.value = true
  if (id && !isArrowPush.value) {
    selected.value = id
    setEarthquakeInfo()
    setCursolTargets()
  }
  isArrowPush.value = false
  isDateChange.value = false
}

const modalAreaClick = function () {
  $('#modal-area').hide()
}

$(document).on('click', function (e) {
  if (!isOpened && $(e.target).closest('.selected').length) {
    isOpened = true
    if ($(e.target).next().hasClass('options')) $(e.target).next().css('display', 'block')
  } else if (isOpened) {
    isOpened = false
    if ($('.selected').next().hasClass('options')) $('.selected').next().css('display', 'none')
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ControllPanel, {
        onClickTarget: handleChangeTarget,
        historyTargets: historyTargets.value
      }, {
        left: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(EarthquakeUdcSelect, {
              class: "select-types country",
              modelValue: earthquakePref.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((earthquakePref).value = $event)),
              onChange: handleChangePref,
              rows: _unref(prefs)
            }, null, 8, ["modelValue", "rows"]),
            _createVNode(EarthquakeUdcSelect, {
              class: "select-types date",
              modelValue: earthquakeDetailTime.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((earthquakeDetailTime).value = $event)),
              onChange: handleChangeDetailTime,
              rows: earthquakeInformations.value
            }, null, 8, ["modelValue", "rows"])
          ])
        ]),
        _: 1
      }, 8, ["historyTargets"])
    ]),
    _hoisted_4,
    _createElementVNode("div", {
      id: "modal-area",
      style: {"display":"none"}
    }, [
      _createElementVNode("div", { id: "modal-content" }, [
        _hoisted_5,
        _createElementVNode("div", {
          class: "sp-bg",
          onClick: modalAreaClick
        }),
        _hoisted_6
      ])
    ]),
    _hoisted_7
  ], 64))
}
}

})